export default "__VITE_ASSET__xewTHNdV__"